export default "__VITE_ASSET__CVQHgYvr__"